import React, { useContext, useMemo } from 'react'
import styled from 'styled-components'
import { BORDER_RADIUS_LARGE } from '../../constants'
import CreationToolFileType from '../../types/file-type'
import CreationToolSourceEditor from '../../types/source-editor'
import { StickerBlock } from '../blocks'
import SourcePlayer from '../source-player'
import Artboard from './artboard'
import { CreationSourceEditorContext } from './manager'
import { getPreviewDimensions } from './utils'

const MAX_WIDTH = 750
const MAX_HEIGHT = 500

const Container = styled(StickerBlock)`
    margin: 0 auto;
    overflow: hidden;
    position: relative;
`

const CreationSourceEditorPreview = () => {
    const { currentEditor, source, edits, outputType, setPreviewPlayheadTime } = useContext(CreationSourceEditorContext)
    const isCropping = currentEditor === CreationToolSourceEditor.Crop
    const isVideo = CreationToolFileType.isVideo(source.type)
    const requiresPlayheadTime = CreationToolSourceEditor.requiresPreviewPlayheadTime(currentEditor)
    const crop = edits?.crop && !isCropping ? edits.crop : undefined
    const sourceAspectRatio = source.width / source.height
    const croppedAspectRatio = crop ? crop.width / crop.height : sourceAspectRatio
    const { width, height } = getPreviewDimensions(croppedAspectRatio, MAX_WIDTH, MAX_HEIGHT)
    const { width: sourceWidth, height: sourceHeight } = getPreviewDimensions(sourceAspectRatio, MAX_WIDTH, MAX_HEIGHT)
    const previewEdits = useMemo(() => ({ trim: edits?.trim, crop }), [edits?.trim, crop])

    return (
        <Container style={{ height, width, borderRadius: isCropping ? 0 : BORDER_RADIUS_LARGE }}>
            <SourcePlayer
                {...{
                    source,
                    overlay: <Artboard width={sourceWidth} height={sourceHeight} />,
                    outputType: edits?.outputType || outputType,
                    edits: previewEdits,
                    forceFrames: !isVideo,
                    onTimeUpdate: requiresPlayheadTime ? setPreviewPlayheadTime : undefined,
                }}
            />
        </Container>
    )
}

export default CreationSourceEditorPreview
